(function () {
    'use strict';
}());